import {Inject, Injectable, Optional} from '@angular/core';
import { RULES_DATA } from './rules-data.token';
import * as rulesV1 from './static-data/rules-data';
import type { RuleTemplate } from './static-data/rules-data';

@Injectable({providedIn: 'root'})
export class RulesService {
  private rulesData = rulesV1;
  path: string = '/api';
  constructor(@Optional() @Inject(RULES_DATA) injectedRulesData?: typeof import('./static-data/rules-data')) {
    if (injectedRulesData) {
      this.rulesData = injectedRulesData;
    }
  }

  getOperatorMap() {
    return this.rulesData.RulesOperatorMap;
  }

  getRuleTemplateMap(): Record<string, RuleTemplate> {
    return this.rulesData.RulesTemplateMap;
  }

  getRuleTemplateMapUta(): Record<string, RuleTemplate> {
    // TODO(strict-typing): `map` (with 'codeshare-flight' removed) is never returned — this
    // method returns the untouched RulesTemplateMap below. Pre-existing dead code; a spec
    // (rules.service.spec.ts) locks in today's unfiltered return, so left as-is rather than
    // guessing at intent. Real fix: confirm product intent, then either delete the `map` local
    // or return it (with the corresponding spec update).
    const map: Partial<typeof this.rulesData.RulesTemplateMap> = { ...this.rulesData.RulesTemplateMap };
    delete map['codeshare-flight'];
    return this.rulesData.RulesTemplateMap;
  }

  getMarketRuleTemplateMap() {
    return this.rulesData.MarketRulesTemplateMap;
  }

  getRuleOptionTypeMap() {
    return this.rulesData.RulesOptionTypeMap;
  }
  getMarketRuleOptionTypeMap() {
    return this.rulesData.MarketRulesOptionTypeMap;
  }
}
